import { useEffect } from "react";
import { NotificationType } from "../../enums/NotificationType";
import { NotificationsItem } from "../molecules/NotificationsItem";
import { useNotifications } from "../../../../context/NotificationContext";
import LoadingSpinner from "../../../../components/LoadingSpinner";

type Props = {
    status?: boolean;
}

export const NotificationsMenu = ({ status }: Props) => {
    const { notifications, loadNotifications, loadUnread, loadingList } = useNotifications();

    useEffect(() => {
        if(!status) {
            loadUnread();
            return;
        }
        loadNotifications();
    }, [status]);

    return (
        <div className="notification-menu">
            <label className="text-center w-100 mb-2 fw-bold"> Notifications </label>
            <div className="notification-list">
                { loadingList ? <LoadingSpinner /> : (
                    notifications.map((n, i) => (
                        <NotificationsItem
                            key={i}
                            type={n.type as NotificationType}
                            title={n.title}
                            message={n.message}
                            createdAt={n.createdAt}
                            isRead={n.isRead}
                            pageLink={n.pageLink}
                        />
                    ))
                )}
            </div>
        </div>
    )
}